import gql from 'graphql-tag';

import { LoyaltyCustomerFragment } from './fragments';

export const GetTriangleRewardsByCustomerId = gql`
  query triangleRewardsByCustomerId($customerId: String!, $partnerId: String) {
    loyaltyByCustomerId(customerId: $customerId) {
      customer {
        ...LoyaltyCustomerFragment
      }
    }
    partnerLink(customerId: $customerId, partnerId: $partnerId) {
      partnerId
      partnerName
      status
      thLinkId
      partnerLinkId
      linkedAt
      delinkedAt
      linkSource
      delinkSource
      hostTransactionId
      rateLimited
      rateLimitRemaining
      retryAfter
      eventCount
      events {
        eventTimestamp
        status
        source
        thLinkId
        partnerLinkId
        hostTransactionId
      }
    }
  }
  ${LoyaltyCustomerFragment}
`;
